/* Injects the bulkkorting nudge ("Nog X stuks voor Y korting") into the UpCart
   drawer. UpCart renders client-side in a shadow DOM, so theme liquid can't
   reach it; instead sections/cart-delivery-data.liquid embeds a map of
   variant_id -> ready-made nudge HTML (computed server-side by
   snippets/bulkkorting-nudge.liquid) and this script mirrors it into the
   drawer. Same integration pattern as upcart-delivery-times.js. */
(function () {
  'use strict';

  var SECTION_ID = 'cart-delivery-data';
  var MAP_TAG_ID = 'vfs-bulkkorting-map';

  var map = {};
  var refetchPending = null;
  var upcartRoot = null;
  var shadowObserver = null;
  var injectTimer = null;

  function parseInlineMap() {
    var el = document.getElementById(MAP_TAG_ID);
    if (!el) return {};
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return {}; }
  }

  function refetch() {
    if (refetchPending) return refetchPending;
    refetchPending = fetch('/?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID] || '';
        var re = new RegExp('<script[^>]*id=["\']' + MAP_TAG_ID + '["\'][^>]*>([\\s\\S]*?)<\\/script>');
        var m = html.match(re);
        map = {};
        if (m && m[1]) {
          try { map = JSON.parse(m[1].trim()); } catch (e) {}
        }
        refetchPending = null;
        inject();
      })
      .catch(function () { refetchPending = null; });
    return refetchPending;
  }

  function getVariantId(item) {
    var link = item.querySelector('a[href*="variant="]');
    if (link) {
      var m = link.getAttribute('href').match(/variant=(\d+)/);
      if (m) return m[1];
    }
    var input = item.querySelector('input[name="id"],input[name*="variant"]');
    if (input && /^\d+$/.test(input.value)) return input.value;
    return null;
  }

  function inject() {
    if (!upcartRoot) return;
    var items = upcartRoot.querySelectorAll('li.upcart-internal-cart-item');

    Array.prototype.forEach.call(items, function (item) {
      var existing = item.querySelector('.vfs-bulkkorting');
      var vid = getVariantId(item);
      var html = vid && map[vid];

      if (!html) {
        if (existing) existing.remove();
        return;
      }
      if (existing) {
        if (existing.__vfsRaw === html) return;
        existing.innerHTML = html;
        existing.__vfsRaw = html;
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'vfs-bulkkorting';
      wrap.innerHTML = html;
      wrap.__vfsRaw = html;

      var tile = item.querySelector('.upcart-internal-component-product-tile__info')
        || item.querySelector('.upcart-internal-component-product-tile__content')
        || item.querySelector('.upcart-internal-component-product-tile')
        || item;
      tile.appendChild(wrap);
    });
  }

  function attachShadowObserver() {
    if (shadowObserver || !upcartRoot) return;
    shadowObserver = new MutationObserver(function () {
      clearTimeout(injectTimer);
      injectTimer = setTimeout(inject, 120);
    });
    shadowObserver.observe(upcartRoot, { childList: true, subtree: true });
    inject();
  }

  function findUpcartRoot() {
    if (upcartRoot) return true;
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) {
      upcartRoot = host.shadowRoot;
      attachShadowObserver();
      return true;
    }
    return false;
  }

  function waitForUpcart() {
    if (findUpcartRoot()) return;
    var bodyObs = new MutationObserver(function () {
      if (findUpcartRoot()) bodyObs.disconnect();
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  map = parseInlineMap();

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string'
      ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function () { setTimeout(refetch, 100); }, function () {});
    }
    return p;
  };

  var origXhrOpen = XMLHttpRequest.prototype.open;
  var origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__vfsBkUrl = url;
    return origXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = this.__vfsBkUrl || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(refetch, 100); });
    }
    return origXhrSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForUpcart);
  } else {
    waitForUpcart();
  }
})();
